import { FC, SVGProps } from 'react'

import styled from 'styled-components'

import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { variables } from 'src/Styled/variables'

const Card = styled.div`
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

const CardHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
`

const CardTitle = styled.div`
  flex: 1 1 0;
  min-width: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: ${variables.lineHeight150per};
  word-break: break-word;
`

const Bullets = styled.ul`
  margin: 0;
  padding-left: 21px;
  width: 100%;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: ${variables.lineHeight150per};

  li {
    word-break: break-word;
  }
`

const ActionButton = styled(GreyTextButton)`
  width: 100%;
  max-width: 320px;
  margin-top: auto;
`

interface PlatformUpsellCardProps {
  Icon: FC<SVGProps<SVGSVGElement>>
  title: string
  bullets: string[]
  buttonLabel: string
  onClick: () => void
}

export const PlatformUpsellCard: FC<PlatformUpsellCardProps> = ({
  Icon,
  title,
  bullets,
  buttonLabel,
  onClick,
}) => (
  <Card>
    <CardHeader>
      <Icon width={24} height={24} />
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <Bullets>
      {bullets.map((bullet) => (
        <li key={bullet}>{bullet}</li>
      ))}
    </Bullets>
    <ActionButton type='button' onClick={onClick}>
      {buttonLabel}
    </ActionButton>
  </Card>
)
